import { LucideIcon } from "lucide-react";
import { Box, Flex, Text } from "@radix-ui/themes";

interface SectionHeaderProps {
  title: string;
  description?: string;
  Icon?: LucideIcon;
}

export function SectionHeader({
  title,
  description,
  Icon,
}: SectionHeaderProps) {
  return (
    <Box mb="6">
      <Flex align="center" gap="3" mb="2">
        {Icon && (
          <Box
            style={{
              padding: "0.5rem",
              borderRadius: "var(--radius-3)",
              backgroundColor: "var(--accent-3)",
            }}
          >
            <Icon size={24} style={{ color: "var(--accent-9)" }} />
          </Box>
        )}
        <Text size="5" weight="medium" style={{ textTransform: "capitalize" }}>
          {title}
        </Text>
      </Flex>
      {description && (
        <Text size="3" color="gray">
          {description}
        </Text>
      )}
    </Box>
  );
}
